import EVENTS from 'Jsx/Utils/tracking/events';

enum TYPES {
  MIXPANEL = 'MIXPANEL',
}

const mixpanel = {
  track(event: string, properties: { [key: string]: any }, callback?) {
    try {
      window.track(event, properties);
      if (callback) {
        setTimeout(callback);
      }
    } catch (error) {
      console.log('Error to send track to mixpanel', error);
    }
  },
  TYPES,
  EVENTS,
  PAGES: {
    SHOPPING_CART: 'Shopping cart',
    CAMPAIGN_LANDING: 'Campaign landing',
  },
};

export default mixpanel;
